var Chaplin, Description, Model, config, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Model = require('models/base/model');

Chaplin = require('chaplin');

config = require('config');

module.exports = Description = (function(_super) {
  __extends(Description, _super);

  function Description() {
    _ref = Description.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  Description.prototype.url = 'catalogue_functions/get_description.php';

  Description.prototype.addToCartURL = 'index.php?go=account.enquiry&do=add&pcsr={%product%}&inc=a';

  Description.prototype.purchaseUrl = 'index.php';

  Description.prototype.defaults = {
    page: null,
    title: null,
    position: {
      left: 0,
      top: 0
    },
    productURL: null
  };

  Description.prototype.fetch = function() {
    return Description.__super__.fetch.call(this, {
      data: "url=" + (this.get('productURL')),
      type: 'post',
      dataType: 'json'
    });
  };

  Description.prototype.addToCart = function(title) {
    var result,
      _this = this;
    if (title == null) {
      title = this.get('title');
    }
    result = $.ajax({
      beforeSend: function() {
        return {};
      },
      method: 'get',
      crossDomain: true,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      url: this.constructorAddToCartURL(title)
    });
    return result.done(function(response) {
      response = response.replace(/^o\|/gi, '');
      _this.set({
        content: response
      }, {
        silent: true
      });
      return _this.publishEvent('catalogue:showAddToCartPopup', _this);
    });
  };

  Description.prototype.constructorAddToCartURL = function(title) {
    var domain;
    domain = this.urlDomain(Chaplin.mediator.catalogue.get('info').url_store);
    return config.api.corsProxy + domain.host.replace(':80', '') + '/' + this.addToCartURL.replace('{%product%}', title);
  };

  Description.prototype.constructorPurchaseURL = function() {
    var domain;
    domain = this.urlDomain(Chaplin.mediator.catalogue.get('info').url_store);
    return config.api.corsProxy + domain.host.replace(':80', '') + '/' + this.purchaseUrl;
  };

  Description.prototype.urlDomain = function(data) {
    var a;
    a = document.createElement('a');
    a.href = data;
    return a;
  };

  Description.prototype.pushPurchaseMessage = function(serializedForm) {
    var result;
    return result = $.ajax({
      beforeSend: function() {
        return {};
      },
      method: 'post',
      crossDomain: true,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: serializedForm,
      url: this.constructorPurchaseURL()
    });
  };

  return Description;

})(Model);
